<template>
    <AppNotLive @openAppWizardModal="$emit('openAppWizardModal')"></AppNotLive>
</template>

<script>

import AppNotLive from 'monetize/adUnitSettings/AppNotLive.vue';
import eventBus from '../mixins/eventBus';


export default {
    name: 'AppNotLiveEx',
    components: { AppNotLive },
    mixins: [
        eventBus('app-not-live-ex')
    ]
};
</script>

<style scoped>

</style>
